import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';
import { CanceledError } from 'axios';

const translate = async (
  text: string,
  targetLanguage: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
): Promise<string | undefined> => {
  try {
    loading(true);
    const { data } = await http.post<{ translations: { text: string }[] }>(
      '/translate',
      { text: [text], target_lang: targetLanguage },
      { signal }
    );
    loading(false);
    return data.translations[0].text;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const translateBulk = async (
  texts: string[],
  targetLanguage: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
): Promise<string[]> => {
  try {
    loading(true);
    const { data } = await http.post<{ translations: { text: string }[] }>(
      '/translate',
      { text: texts, target_lang: targetLanguage },
      { signal }
    );
    loading(false);
    return data.translations.map((t) => t.text);
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
    return [];
  }
};

const WidgetService = {
  translate,
  translateBulk,
};

export default WidgetService;
